// Catalog.ID Client — Token API
// ============================================================================
// /api/token is a JSON endpoint (not OAuth form-encoded). Fields on the wire
// are camelCase to match ASP.NET Core's default serialization of the server's
// TokenRequest record. Response is `{ accessToken, refreshToken, expiresIn }`.

import { api } from './client';
import type {
    AgentDelegationRequest, RefreshTokenRequest, ApiKeyTokenRequest,
    TokenResponse,
} from './types';

export async function agentDelegationGrant(
    agentCid: string,
    scopes: string[],
    persistent?: boolean,
): Promise<TokenResponse> {
    const body: AgentDelegationRequest = {
        grantType: 'agent_delegation',
        agentCid,
        scopes,
        ...(persistent !== undefined ? { persistent } : {}),
    };
    return api.post('/api/token', body);
}

export async function refreshToken(refreshToken: string): Promise<TokenResponse> {
    const body: RefreshTokenRequest = {
        grantType: 'refresh_token',
        refreshToken,
    };
    return api.post('/api/token', body);
}

export async function apiKeyGrant(key: string, secret: string): Promise<TokenResponse> {
    const body: ApiKeyTokenRequest = {
        grantType: 'agent_apikey',
        key,
        secret,
    };
    return api.post('/api/token', body);
}
